import { CONNECT_TO_SALES_PATH } from 'components/App/Routes/Routes';

/*
Opens connect to sales page in new tab for a modal.
@returns true so modal does not close.
 */
export const onModalContactSalesClick = () => {
  window.open(CONNECT_TO_SALES_PATH, '_blank', 'noopener,noreferrer');
  return true;
};
